<div class="container-fluid pagecard licenses-main-page" id="licenses-list-page">

  <div *ngIf="isEmpty" class="reports-no-discounts">
    <div class="empty-discounts-note">
      <div class="image_theme">
        <img
          src="assets/images/empty-report-icon.svg"
          width="65px"
          alt="Empty Report Icon"
        />
        <!-- <h2 class="fw-600 mb-3">{{ "Maarketing Recommendation" }}</h2> -->
          <!-- <p class="f-16 mb-3">{{ "No Upcoming Events" }}</p> -->
          <!-- <button class="create-btn" (click)="goToAddPage()">
            {{ "Generate Recommendations" }}
          </button> -->
      </div>
      <div style="margin: 10px; font-size: xx-large;">
        {{ "No Upcoming Events" }}
      </div>
      <button style="margin: 5px;" class="create-btn" (click)="openAddShiftModal()">
        {{ "Generate Recommendations" }}
      </button>
       <div>

       </div>
    </div>
  </div>

  <div class="gross-details-accordion-dropdown-arrow" *ngIf="!isEmpty">
    <!-- <div class="gross-details-accordion-dropdown-arrow" *ngIf="!emptydata"> -->
      <div class="mb-3">
        <div class="">
          <div class="table-responsive report_table mb-4">
            <table id="licenses-table" class="display w-100" cellspacing="0" width="100%">
                <thead class="w-100">
                    <tr>
                        <th class="text-start">&nbsp; &nbsp; Name</th>
                        <th class="text-center table-header-space">Description</th>
                        <th class="text-center table-header-space">Start Date</th>
                        <th class="text-center table-header-space">End Date</th>
                        <th class="text-center table-header-space">Status</th>
                        <th class="text-center table-header-space">Expiration Date</th>
                        <!-- <th class="text-end"></th> -->
                    </tr>
                </thead>
                <tbody>

                    <tr *ngFor="let event of allEventsList">
                        <td class="text-start">{{event.name || 'Upcoming Event'}}</td>
                        <td class="text-center  description-cell">{{event.description || 'No description available'}}</td>
                        <td class="text-center">{{event.startdate || eventStartDate | date: 'MM/dd/yyyy'}}</td>
                        <td class="text-center">{{event.enddate || eventEndDate | date: 'MM/dd/yyyy'}}</td>
                        <td class="text-center">
                          <ui-switch
                            defaultBoColor="#dfdfdf"
                            color="#666666"
                            uncheckedLabel="OFF"
                            checkedLabel="ON"
                            size="small"
                            [checked]="event.status === 1 ? true : false"
                            (change)="onActiveStatusChange(event, $event)"
                            switchColor="black"
                          >
                          </ui-switch>
                        </td>
                        <td class="text-center">{{event.expirationdate || eventEndDate | date: 'MM/dd/yyyy'}}</td>
                    </tr>

                </tbody>
            </table>
        </div>
        </div>
      </div>
      <div class="position-absolute" style="right: 0; top: 20px; z-index: 900;">
        <button accessControl module="License" access="3" class="new-btn" (click)="openAddShiftModal()">
          + Generate
        </button>
      </div>
  </div>
</div>

<ng-template #content1 role="document" let-modal>
  <div class="modal-body border-0">
    <div class="delete-icon-info">
      <div
        class="swal2-icon swal2-warning swal2-icon-show"
      >
        <div class="swal2-icon-content">!</div>
      </div>
      <h2 class="swal2-title" id="swal2-title" style="display: flex">
            Are you sure?
      </h2>
    </div>
  </div>
  <div class="modal-footer border-0">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-12 text-center">
          <button
            class="btn add-btn-one fw-bold"
              (click)="deleteLicense(content1)"
          >
            Yes, Delete it!
          </button>
          <button
            class="btn btn-dark fw-bold add-btn-two"
            style="margin-left: 15px"
            (click)="cancelDeleteAll(content1)"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #addShift let-modal>
  <form>
    <div [formGroup]="addShiftForm" class="modal-body">
      <div class="d-flex justify-content-between mb-4">
        <div class="f-20 fw-600">{{'Add details' | translate | async }}</div>
        <div>
          <button class="bg-transparent border-0">
            <img src="assets\images\closeIcon.svg" class="" (click)="dismissAddShiftModal()" />
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <label for="coursename" class="form-label">{{'Date Range' | translate | async }}<img
                src="assets\images\!.png" /></label>
            <div class="datepickerwrap" daterangepicker [options]="daterangeOptions"
              (selected)="rangeselectedDate($event)">
              <div class="d-flex justify-content-between">
                <div class="text-start ms-2 ps-0">
                  <span>{{ rangestartDateDisplay | translate | async }} -
                    {{ rangeendDateDisplay | translate | async }}</span>
                </div>
                <img src="/assets/images/calendarDark.png" alt="" style="height: 20px" class="cursor-pointer" />
              </div>
            </div>
          </div>
          <div class="form-text text-danger" *ngIf="
              !addShiftForm.controls.endDate.valid &&
              addShiftForm.controls.endDate.touched
            ">
            {{'Please provide a valid date range.' | translate | async }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <label for="coursename" class="form-label">{{'Country' | translate | async }}</label>
            <input type="text" class="form-control" id="country" formControlName="country"
              placeholder="{{'Country Name' | translate | async}}" />
          </div>
          <div class="form-text text-danger" *ngIf="
              !addShiftForm.controls.country.valid &&
              addShiftForm.controls.country.touched
            ">
            {{'Please provide a valid country name.' | translate | async }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <label for="coursename" class="form-label">{{'State' | translate | async }}</label>
            <input type="text" class="form-control" id="state" formControlName="state"
              placeholder="{{'State Name' | translate | async}}" />
          </div>
          <!-- <div class="form-text text-danger" *ngIf="
              !addShiftForm.controls.state.valid &&
              addShiftForm.controls.state.touched
            ">
            {{'Please provide a valid state name.' | translate | async }}
          </div> -->
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <label for="coursename" class="form-label">{{'City' | translate | async }}</label>
            <input type="text" class="form-control" id="city" formControlName="city"
              placeholder="{{'City Name' | translate | async}}" />
          </div>
          <!-- <div class="form-text text-danger" *ngIf="
              !addShiftForm.controls.city.valid &&
              addShiftForm.controls.city.touched
            ">
            {{'Please provide a valid city name.' | translate | async }}
          </div> -->
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <button
            class="primary_btn f-18 w-100 mb-3 fw-700 text-white" type="submit"
            (click)="onSubmitAddShift()"
            [disabled]="!this.addShiftForm.valid">
            {{'Generate' | translate | async }}
          </button>

          <!-- <button *ngIf="isLoading"
            class="primary_btn f-18 w-100 fw-700 text-white" type="button" disabled>
            <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
            <span class="pl-2">&nbsp;&nbsp;{{'Please wait...' | translate | async }}</span>
          </button> -->
        </div>
      </div>
    </div>
  </form>
</ng-template>
